import React, { useState, useEffect } from "react";
import { Box, Typography } from "@mui/material/";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Branches from "./Branches";
import Locations from "./Locations";
import Groups from "./Groups";
import User from "./User";
import { strings } from "../common/i18n";
import styles from "./styles";
import actions from "../Store/actions";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { logToSentry } from "../config/Sentry";

export default () => {
    const dispatch = useDispatch();
    const [value, setValue] = useState("branches");
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        (async () => {
            try {
                // Load audit group  and accounts promise all for other tab request to load
                await Promise.all([
                    await dispatch(actions.auditGroups.create.getRequest()),
                    await dispatch(actions.accounts.create.getRequest())
                ]);
            } catch (error) {
                logToSentry("On manage page load:", { error: error });
                console.error(error);
            }
            // finally {
            //     setLoading(false);
            // }
        })();
    }, []);


    // Clear account item if URL still points to a detail/create route on a non-users tab
    useEffect(() => {
        const notUsers = value !== "users";
        const endsWithCreateOrId = /\/(create|\d+)$/.test(location.pathname);
        if (notUsers && endsWithCreateOrId) {
            dispatch(actions.accounts.create.itemReset());
        }
    }, [value, location.pathname]);

    const handleChange = (event, newValue) => {
        if (value === "users" && newValue !== "users") {
            dispatch(actions.accounts.create.itemReset());
            // If URL is at a user detail/create route, navigate back to the users list
            // so React Router renders UsersListTable instead of Account on return
            if (/\/(create|\d+)$/.test(location.pathname)) {
                navigate(location.pathname.replace(/\/(create|\d+)$/, ""), { replace: true });
            }
        }
        setValue(newValue);
    };


    return (
        <Box>
            <Box sx={styles.mainHeaderContainer}>
                <Typography variant="h6" sx={styles.mainHeader}>
                    {`${strings("manage")}`}
                </Typography>
                <Box />
            </Box>
            <TabContext value={value} sx={styles.tabContext}>
                <Box sx={styles.tabListContainer}>
                    <TabList onChange={handleChange}>
                        <Tab label={strings("branches")} value="branches" />
                        <Tab label={strings("locations")} value="locations" />
                        <Tab label={strings("groups")} value="groups" />
                        <Tab label={strings("users")} value="users" />
                    </TabList>
                </Box>
                <TabPanel value="branches" sx={styles.tabPanelList}>
                    <Branches />
                </TabPanel>
                <TabPanel value="locations" sx={styles.tabPanelList}>
                    <Locations />
                </TabPanel>
                <TabPanel value="groups" sx={styles.tabPanelList}>
                    <Groups />
                </TabPanel>
                <TabPanel value="users" sx={styles.tabPanelList}>
                    <User />
                </TabPanel>
            </TabContext>
        </Box>
    );
};
